import 'firebase/analytics';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
import moment from 'moment-timezone';
import ENV from './env.json';

// This fixes some node modules that uses the (node) global variable that is missing in browsers.
// We’re using client code because replacing it with Vite’s define is discouraged.
// See: https://vitejs.dev/config/shared-options.html#define
if (typeof window.global === 'undefined') {
  // @ts-ignore
  window.global = window;
}

firebase.initializeApp(ENV.firebase);


if (
  window.location.hostname !== 'localhost' ||
  ENV.googleAnalytics.trackLocalhost
) {
  firebase.analytics();
}

// See e.g. https://github.com/moment/moment-timezone/issues/888
const singapore = moment.tz.zone('Asia/Singapore');
if (singapore) {
  singapore.abbrs[0] = 'SGT';
}
